const installScript = ({
  onLoadCallback,
  scriptSrc,
  uniqueScriptId,
  dataMain,
  innerHTML,
  attributes,
}) => {
  const existingScript = document.getElementById(uniqueScriptId);
  if (existingScript && onLoadCallback) {
    onLoadCallback();
    return false;
  }

  const script = document.createElement('script');
  script.id = uniqueScriptId;
  if (scriptSrc) script.src = scriptSrc;
  if (onLoadCallback) script.onload = onLoadCallback;
  if (dataMain) script.setAttribute('data-main', dataMain);
  if (innerHTML) script.innerHTML = innerHTML;
  if (attributes && typeof attributes === 'object') {
    for (let i in attributes) {
      script.setAttribute(`data-${i}`, attributes[i]);
    }
    /* !!! Not supported in IE !!!
    const attrs = Object.entries(attributes);
    attrs.forEach((attr) => {
      script.setAttribute(`data-${attr[0]}`, attr[1]);
    });
    */
  }

  document.head.appendChild(script);

  return script;
};

export { installScript };
